import React from 'react';
import { Tag, Typography } from 'antd';
import { YoutubeOutlined, TwitterOutlined, FacebookOutlined, InstagramOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface SocialTagProps {
	url: string;
	name: string;
}

const SocialTag: React.FC<SocialTagProps> = ({ url, name }) => {
	if (!url || url === '') {
		return <div></div>;
	}

	// Extract platform from URL
	const getPlatformFromUrl = (url: string): string => {
		try {
			const urlObj = new URL(url);
			const hostname = urlObj.hostname.toLowerCase();
			
			if (hostname.includes('youtube.com') || hostname.includes('youtu.be')) {
				return 'youtube';
			} else if (hostname.includes('twitter.com') || hostname.includes('x.com')) {
				return 'twitter';
			} else if (hostname.includes('facebook.com')) {
				return 'facebook';
			} else if (hostname.includes('instagram.com')) {
				return 'instagram';
			}
			return 'default';
		} catch {
			return 'default';
		}
	};

	const platform = getPlatformFromUrl(url);

	const renderTag = () => {
		switch (platform) {
			case 'youtube':
				return (
					<Tag icon={<YoutubeOutlined />} color="#cd201f">
						<Text style={{ maxWidth: '100px', color: 'white' }} ellipsis>
							{name}
						</Text>
					</Tag>
				);
			case 'twitter':
				return (
					<Tag icon={<TwitterOutlined />} color="#55acee">
						<Text style={{ maxWidth: '100px', color: 'white' }} ellipsis>
							{name}
						</Text>
					</Tag>
				);
			case 'facebook':
				return (
					<Tag icon={<FacebookOutlined />} color="#3b5999">
						<Text style={{ maxWidth: '100px', color: 'white' }} ellipsis>
							{name}
						</Text>
					</Tag>
				);
			case 'instagram':
				return (
					<Tag icon={<InstagramOutlined />} color="#F77737">
						<Text style={{ maxWidth: '100px', color: 'white' }} ellipsis>
							{name}
						</Text>
					</Tag>
				);
			default:
				return (
					<Tag>
						<Text style={{ maxWidth: '100px', color: 'white' }} ellipsis>
							{name}
						</Text>
					</Tag>
				);
		}
	};

	return (
		<a 
			target="_blank" 
			href={url} 
			rel="noopener noreferrer"
			style={{ textDecoration: 'none' }}
		>
			{renderTag()}
		</a>
	);
};

export default SocialTag;
